export const getSmoothedSpeeds = (pings, windowSize = 5) => {
    const speeds = pings.map((p) => p.speedKilometresPerHour);
    return speeds.map((_, i) => {
        const start = Math.max(0, i - windowSize);
        const end = Math.min(speeds.length - 1, i + windowSize);
        const windowValues = speeds
            .slice(start, end + 1)
            .filter((s) => typeof s === "number" && !Number.isNaN(s));
        if (windowValues.length === 0) return null;
        return windowValues.reduce((sum, s) => sum + s, 0) / windowValues.length;
    });
};
